/** Templates */
import openedgePaymentDialogTemplate from './openedgePaymentDialog.html';
import './openedgePaymentDialog.scss';

/*******************************************************************************
 * OpenEdge Payment Dialog
 *******************************************************************************/

/*--------------------------------------------*/
/* PayFields CSS configuration. Style file    */
/* must be in the same folder as this script. */
/*--------------------------------------------*/
var PayFieldsCSS = {
  filename: 'openedgePayfields.iframe.css', // Name of style file parsed for styles.
  config: 'payfields-config', // Styles to add to API at configuration.
  invalid: 'payfields-invalid' // Styles to add to API for invalid fields after first submit button click.
};

/*-----------*/
/* Directive */
/*-----------*/
export function openedgePaymentDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    scope: {
      config: '<',
      cartTotal: '<',
      onClick: '&',
      onCommit: '&',
      onFail: '&'
    },
    template: openedgePaymentDialogTemplate,
    backdrop: 'static',
    windowClass: 'payment-card-dialog openedge-payment-dialog',
    preloader: 'onClick',
    controller: controller
  });
}

/*------------*/
/* Controller */
/*------------*/
function controller($scope, $uibModalInstance, $injector, $q, $preloaded) {
  var $svcs = {
    $ctrl: this,
    $global: {},
    $scope: $scope,
    $uibModalInstance: $uibModalInstance,
    $preloaded: $preloaded
  };
  var $ctrl = $injector.invoke(
    init$ctrl,
    null,
    ($svcs = Object.assign($svcs, { $svcs: $svcs }))
  );
  var $global = $injector.invoke(init$global, null, $svcs);
  var pageReady = $injector.invoke(initPage, null, $svcs);

  /*------------------------------------------*/
  /* Get `PaymentCardDialog' validator method */
  /* for validation of billing address info.  */
  /*------------------------------------------*/
  $ctrl.dialogLoaded = function ($validator) {
    $ctrl.validateDialog = $validator;
  };

  /*----------------------------------------*/
  /* Initialize payfields when javascript   */
  /* is loaded and dialog form is rendered. */
  /*----------------------------------------*/
  $q.all([pageReady, $uibModalInstance.rendered])
    .then(function () {
      $injector.invoke(initPayfields, null, $svcs);

      /*-----------------------------------------------*/
      /* Load complete/cancel page when dialog closes. */
      /*-----------------------------------------------*/
      return $uibModalInstance.result;
    })

    /*------------------------------------------------------------------*/
    /* Load the return URL if the dialog closed after token generation. */
    /*------------------------------------------------------------------*/
    .then(() => (window.location.href = $preloaded.returnURL))

    /*------------------------------------------------------------*/
    /* If the promise is rejected, the dialog has been dismissed. */
    /* Load the cancel URL for cancel button or escape key.       */
    /* Otherwise, call the fail handler with the error info.      */
    /*------------------------------------------------------------*/
    .catch((reason) => {
      if (!reason || reason === 'escape key press')
        window.location.href = $preloaded.cancelURL;
      else $ctrl.onFail({ $reason: reason });
    });
}

/*******************************************************************************
 * init$ctrl */
/**
 * $ctrl property initializer.
 *
 * @param  $ctrl  Controller object.
 * @param  $svcs  Properties to pass with `$injector.invoke()`.
 * @return $ctrl
 *******************************************************************************/
/* @ngInject */ function init$ctrl(
  $svcs,
  $ctrl,
  $global,
  $injector,
  PaymentsData
) {
  return Object.defineProperties(
    Object.assign($ctrl, {
      /*----------*/
      /* Handlers */
      /*----------*/
      submit: $injector.invoke(submit, null, $svcs),

      /*---------------------*/
      /* Billing info model. */
      /*---------------------*/
      billingInfo: new PaymentsData.BillingInfo(),

      /*-------------------------------------------------*/
      /* waitingForToken - Set when payfields button is  */
      /* clicked and cleared on token generation result. */
      /*-------------------------------------------------*/
      waitingForToken: false
    }),

    /*-----------*/
    /* Accessors */
    /*-----------*/
    {
      /*------------------------------------------------------------------*/
      /* payfieldsReady - `true` when all payfields have been registered. */
      /*------------------------------------------------------------------*/
      payfieldsReady: {
        get: function () {
          return Object.keys($global.payfields.fields).every(function (name) {
            return $global.payfields.fields[name].ready;
          });
        }
      },

      /*-----------------------------------*/
      /* readyForInput - Hides busy panel. */
      /*-----------------------------------*/
      readyForInput: {
        get: function () {
          return $ctrl.payfieldsReady && !$ctrl.waitingForToken;
        }
      },

      /*----------------------------------------------------------*/
      /* readyForToken - `true` when all payfields inputs are     */
      /* valid. Swaps submit button with payfields submit button. */
      /*----------------------------------------------------------*/
      readyForToken: {
        get: function () {
          return Object.keys($global.payfields.fields).every(function (name) {
            return $global.payfields.fields[name].valid;
          });
        }
      }
    }
  );
}

/*******************************************************************************
 * init$global */
/**
 * $global property initializer.
 *
 * @param  $global Global properties and methods.
 * @param  $svcs   Properties to pass with `$injector.invoke()`.
 * @return $global
 *******************************************************************************/
/* @ngInject */ function init$global($svcs, $global, $injector) {
  return Object.assign($global, {
    /*---------*/
    /* Methods */
    /*---------*/
    payfieldsHandler: $injector.invoke(payfieldsHandler, null, $svcs),

    /*------------*/
    /* Properties */
    /*------------*/
    payfields: {
      /*--------------------------------------------------------------*/
      /* Payfield Definitions                                         */
      /*                                                              */
      /*  <key> = Payfields field type.                               */
      /*  ready = Ready for input flag. Set when field is registered. */
      /*  valid = Input valid flag. Set/cleared on field test event.  */
      /*  specs = Properties passed in form initialization.           */
      /*--------------------------------------------------------------*/
      fields: {
        'card-number': {
          ready: false,
          valid: false,
          specs: {
            target: '#card-number',
            placeholder: '•••• •••• •••• ••••'
          }
        },
        'card-expiration': {
          ready: false,
          valid: false,
          specs: { target: '#card-expiration', placeholder: 'MM / YY' }
        },
        'card-cvv': {
          ready: false,
          valid: false,
          specs: { target: '#card-cvv', placeholder: '•••' }
        },
        submit: {
          ready: false,
          valid: true,
          specs: { target: '#submit', text: 'Pay Now' }
        }
      },

      /*-------------------------------------------*/
      /* Styles added to payfields form with       */
      /* `addStylesheet()`. Created in `initPage`. */
      /*-------------------------------------------*/
      styles: {
        /*---------------------------------*/
        /* Added when form is initialized. */
        /*---------------------------------*/
        config: null,

        /*--------------------------------------*/
        /* Added after first error button click */
        /* event to show card input data errors */
        /*--------------------------------------*/
        invalid: null
      }
    }
  });
}

/*******************************************************************************
 * initPage */
/**
 * Loads browser page resources. Loads javascript from GlobalPayments and the
 * stylesheet with styles to pass to the PayFields API. Returns a promise
 * resolved when the javascript and stylesheet have both been loaded. Rejects the
 * promise and dismisses the dialog if an error occurs.
 *
 * @returns {Promise} Resolved when page resources have been loaded.
 *                    Rejected if script file fails to load.
 *******************************************************************************/
/* @ngInject */ function initPage(
  $ctrl,
  $global,
  $interval,
  $q,
  $uibModalInstance,
  AssetFiles,
  DOMTools
) {
  /*----------------------------------------*/
  /* Load the payfields javascript from     */
  /* Global Payments if not already loaded. */
  /*----------------------------------------*/
  if (!window.checkoutReady) {
    /*-----------------------------------------------*/
    /* Add script tag to load the PayFields JS from  */
    /* Global Payments and add load/error listeners. */
    /*-----------------------------------------------*/
    var head = document.querySelector('head');
    var script = document.createElement('script');
    script.src = $ctrl.config.scriptURL;
    script.addEventListener('load', () => (window.scriptLoaded = true));
    script.addEventListener('error', () => (window.scriptLoaded = false));
    head.appendChild(script);

    window.checkoutReady = $q(function (resolve, reject) {
      var timer = $interval(
        function () {
          if (!angular.isUndefined(window.scriptLoaded)) {
            $interval.cancel(timer);

            if (window.scriptLoaded)
              if (window.GlobalPayments) resolve();
              else
                reject(`Script file '${$ctrl.config.scriptURL}' is not valid.`);
            else
              reject(
                `Script file '${$ctrl.config.scriptURL}' could not be loaded.`
              );
          }
        },
        100,
        100,
        false
      );
    });
  }

  /*------------------------------------------------------*/
  /* Load the payfields stylesheet and set style objects. */
  /*------------------------------------------------------*/
  var cssFile = AssetFiles[PayFieldsCSS.filename] || PayFieldsCSS.filename;
  /**
   * We want to provide OpenEdge with the location of our CSS file for styling the
   * PaymentFrame IFRAME fields. This file is located in the "dist" folder
   * alongside our other built assets.
   *
   * The url will look like this:
   * https://your-domain/store/client/dist/openedgePayfields.iframe.css
   */
  var cssURL = `${window.location.origin}/store/client/dist/${cssFile}`;
  var stylesLoaded = DOMTools.loadStyleSheetRules(cssURL).then(
    function (rules) {
      $global.payfields.styles = {
        config: DOMTools.createStylesObject(rules, PayFieldsCSS.config),
        invalid: DOMTools.createStylesObject(rules, PayFieldsCSS.invalid)
      };
      return $q.resolve();
    }
  );

  /*--------------------------------------*/
  /* Close the dialog if an error occurs. */
  /*--------------------------------------*/
  return $q
    .all([window.checkoutReady, stylesLoaded])
    .catch((r) => $uibModalInstance.dismiss(r));
}

/*******************************************************************************
 * initPayfields */
/**
 * Configures Payfields API, initializes form, and assigns field event handlers.
 * Dialog is ready for input when all payfields are ready.
 *
 * @param  $svcs  Properties to pass with `$injector.invoke()`.
 *******************************************************************************/
/* @ngInject */ function initPayfields($svcs, $ctrl, $global, $injector) {
  /*--------------------------*/
  /* Configure payfields API. */
  /*--------------------------*/
  GlobalPayments.configure({
    'X-GP-Api-Key': $ctrl.config.apiKey,
    'X-GP-Environment': $ctrl.config.environment,
    enableAutocomplete: true
  });

  /*-----------------------*/
  /* Initialize payfields. */
  /*-----------------------*/
  $global.cardForm = GlobalPayments.ui.form({
    fields: Object.keys($global.payfields.fields).reduce(function (
      fields,
      name
    ) {
      fields[name] = $global.payfields.fields[name].specs;
      return fields;
    }, {}),

    styles: $global.payfields.styles.config
  });

  /*-------------------------------------------------------------*/
  /* "click" listener shows busy panel which token is generated. */
  /*-------------------------------------------------------------*/
  $global.cardForm.on(
    'click',
    $global.payfieldsHandler(function () {
      $ctrl.waitingForToken = true;
    })
  );

  /*-------------------------------------------------*/
  /* "register" listener sets payfield `ready` flag. */
  /* Dialog is ready when all fields are ready.      */
  /*-------------------------------------------------*/
  $global.cardForm.on(
    'register',
    $global.payfieldsHandler(function (field) {
      $global.payfields.fields[field.type].ready = true;
    })
  );

  /*---------------------------------------------------*/
  /* "-test" listeners set payfield `valid` flag.      */
  /* Token can be generated when all fields are valid. */
  /*---------------------------------------------------*/
  ['card-number', 'card-expiration', 'card-cvv'].forEach(function (type) {
    $global.cardForm.on(
      type + '-test',
      $global.payfieldsHandler(function (data) {
        $global.payfields.fields[type].valid = data.valid;
      })
    );
  });

  /*------------------------------------------------*/
  /* Call submit for a successful token generation. */
  /*------------------------------------------------*/
  $global.cardForm.on('token-success', $global.payfieldsHandler($ctrl.submit));

  /*-----------------------------------------------------------*/
  /* Add error listeners to dismiss the dialog. Since the      */
  /* payfields submit button is only available when all CHD    */
  /* is valid, `token-error` will only be sent when there is   */
  /* a problem with tokenization like an authentication error. */
  /*-----------------------------------------------------------*/
  var errorHandler = $injector.invoke(onError, null, $svcs);

  $global.cardForm.on('token-error', errorHandler);
  GlobalPayments.on('error', errorHandler);

  /*-----------------------------------*/
  /* Unused handlers:                  */
  /*                                   */
  /* card-type - Card type identified. */
  /* resize    - Payfield resized.     */
  /*-----------------------------------*/
  //$global.cardForm.on("card-type", function(data) { console.log("card-type: ", data); });
  //$global.cardForm.on("resize",    function(data) { console.log("resize: ",    data); });
}

/*****************************************************************************
 * $global.cardForm.onError */
/**
 * Errors from GlobalPayments javascript. These errors are fatal and will
 * dismiss the dialog with `data`.
 *****************************************************************************/
/* @ngInject */ function onError($ctrl, $global, $uibModalInstance) {
  return $global.payfieldsHandler(function (data) {
    console.error('Fatal: ', data);
    $uibModalInstance.dismiss(data);
  });
}

/*****************************************************************************
 * $global.payfieldsHandler */
/**
 * Returns a handler for payfields events. These events are fired from outside
 * AngularJS so `handler` is called using `$timeout` to fire a digest cycle.
 *****************************************************************************/
/* @ngInject */ function payfieldsHandler($timeout) {
  return function (handler) {
    return function (data) {
      $timeout(handler(data));
    };
  };
}

/*****************************************************************************
 * $ctrl.submit */
/**
 * Submit button handler. Called by submit button and payfields 'token-error'
 * and 'token-success' events. Adds `invalid` stylesheet to payfields,
 * and validates address fields. Evaluates `onCommit` and closes the dialog if
 * all input is valid.
 *
 * @param {object} data  Event info.
 *   - `undefined` when from submit button.
 *   - `{error:{code,info,message}}` for `token-error`.
 *   - `{card,temporary_token}` for `token-success`.
 *****************************************************************************/
/* @ngInject */ function submit($ctrl, $global, $uibModalInstance) {
  var stylesAdded = false;

  return function (data) {
    if (data) console.error(data);

    $ctrl.waitingForToken = false;

    /*---------------------------------------*/
    /* Add styles for not `valid` payfields. */
    /*---------------------------------------*/
    if (!stylesAdded)
      $global.cardForm.addStylesheet($global.payfields.styles.invalid);
    stylesAdded = true;

    /*-----------*/
    /* Validate. */
    /*-----------*/
    if ($ctrl.validateDialog($ctrl.readyForToken)) {
      //$ctrl.waitingForToken   = true;

      $ctrl.billingInfo.cardToken = data.temporary_token;

      $ctrl.onCommit({ $billingInfo: $ctrl.billingInfo }).then(function (r) {
        $uibModalInstance.close();
      });
    }
  };
}
